export const PROGRAM_NAMES = {
  DMEPOS: 'DMEPOS'
} as const;

export const PLAN_TYPES = {
  MEDICARE_ADVANTAGE: 'Medicare Advantage'
} as const;

export const DEFAULT_FORM_NAMES = {
  DMEPOS_NO_AUTO_ADJUDICATION: 'DMEPOS-No Auto Adjudication Clinical Question'
} as const;

export const DMEPOS_CATEGORIES = {
  INCOMPLETE: 'incomplete'
} as const;
